import { Button, Form, Col, Offcanvas, Row } from "react-bootstrap";
import { Controller, set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";
import Select from "react-select";
import PlotDatePicker from "../../components/PlotDatePicker/PlotDatePicker";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
    isRed: boolean;
    projectList?: any[];
    vendorList?: any[];
}

interface formInterface {
    id: number
    uuid?: string
    project_id: number
    vendor_id: number
    stock_id: number
    unit_id: number
    unit?: string
    quantity: number
    internal_key: string
    cost: number
    inventory_date: Date
    status: 'ACTIVE' | 'PAID' | 'DELETED'
    created_by?: number
    created_at?: Date
    updated_at?: Date
    cost_per_unit?: number
}

const AddInventory = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue, register } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [stockList, setStockList] = useState<any[]>([]);
    const [isLoadingStock, setIsLoadingStock] = useState<boolean>(false);
    const [projectList, setProjectList] = useState<any[]>([]);
    const [vendorList, setVendorList] = useState<any[]>([]);

    useEffect(() => {
        props.projectList && setProjectList(props.projectList);
        props.vendorList && setVendorList(props.vendorList);
    }, [props.projectList, props.vendorList]);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                console.log("props.data", props.data);
                setValue("id", props.data.id);
                setValue("uuid", props.data.uuid);
                setValue("project_id", props.data.project_id);
                setValue("vendor_id", props.data.vendor_id);
                setValue("stock_id", props.data.stock_id);
                setValue("unit_id", props.data.unit_id);
                setValue("quantity", props.data.quantity);
                setValue("cost", props.data.cost);
                setValue("inventory_date", new Date(props.data.inventory_date));
                setValue("unit", props.data.unit?.name);
                setValue("cost_per_unit", Number(props.data.cost) / Number(props.data.quantity));
                //  reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
            !stockList.length && getStockList();
        }
    }, [props.isShow, props.data]);

    const getStockList = () => {
        setIsLoadingStock(true);
        WebService.getAPI({ action: "stock/list" })
            .then((res: any) => {
                setStockList(res.list.map((item: any) => { return { ...item, ...{ value: item.id, label: item.name } } }));
                setIsLoadingStock(false);
            }).catch((e: any) => { setIsLoadingStock(false); })
    };

    const handleFormSubmit = (data: formInterface) => {
        const url = isEdit ? `inventory/update` : "inventory/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn", is_session: props.isRed
        }).then((res: any) => {
            toast.success(res.message);
            closeModal(true);
        }).catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        reset({});
    };


    return (
        <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
            <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Inventory" : "Add Inventory"}</Offcanvas.Title></Offcanvas.Header>
            <Offcanvas.Body className="form-style">
                <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                    <Row>
                        <Col lg={12} md={6} sm={12} className="mb-3">
                            <Controller
                                control={control}
                                name="project_id"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Project</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={projectList}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={projectList?.find((option: any) => option.value === watchAllFields.project_id)}
                                                placeholder="Select Project"
                                            />
                                        </div>
                                        {errors.project_id && (<div className="login-error mb-3"> <Label title={"Please select project"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            <Controller
                                control={control}
                                name="vendor_id"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Supplier</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={vendorList}
                                                onChange={(e: any) => { onChange(e.value); }}
                                                value={vendorList?.find((option: any) => option.value === watchAllFields.vendor_id)}
                                                placeholder="Select Supplier"
                                            />
                                        </div>
                                        {errors.vendor_id && (<div className="login-error mb-3"> <Label title={"Please select supplier"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            <Controller
                                control={control}
                                name="stock_id"
                                rules={{ required: true }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Stock</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <Select
                                                isLoading={isLoadingStock}
                                                className="basic-single w-100"
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                options={stockList}
                                                onChange={(e: any) => { onChange(e.value); setValue('unit_id', e.unit_id); setValue('unit', e.unit.name) }}
                                                value={stockList?.find((option: any) => option.value === watchAllFields.stock_id)}
                                                placeholder="Select Stock"
                                            />
                                        </div>
                                        {errors.stock_id && (<div className="login-error mb-3"> <Label title={"Please select stock"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )}
                            />

                            <div className="d-flex">
                                <Form.Group className="mb-3 w-100">
                                    <Form.Label>Quantity</Form.Label>{" "}
                                    <span className="text-danger">*</span>
                                    <div className="input-group mb-1">
                                        <input type="text" className="form-control ps-3 p-2" placeholder={"Quantity"} {...register("quantity", { required: true })} onKeyPress={HelperService.allowNewDecimalValue} value={watchAllFields.quantity} />
                                    </div>
                                    {errors.quantity && (<div className="login-error mb-3"> <Label title={"Please enter quantity"} modeError={true} /> </div>)}
                                </Form.Group>
                                <div className="align-self-end ms-2 mb-3">{watchAllFields.unit}</div>
                            </div>


                            {
                                watchAllFields.stock_id && watchAllFields.quantity && watchAllFields.unit_id && (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cost per {watchAllFields.unit}</Form.Label>{" "}
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <input type="text" className="form-control ps-3 p-2" placeholder={`Enter Cost per ${watchAllFields.unit}`} onKeyPress={HelperService.allowOnlyNumericValue} value={watchAllFields.cost_per_unit}
                                                onChange={(e: any) => { e.target.value && setValue("cost", Number(e.target.value) * watchAllFields.quantity); setValue("cost_per_unit", e.target.value) }} />
                                        </div>
                                        {errors.cost && (<div className="login-error mb-3"> <Label title={"Please enter cost"} modeError={true} /> </div>)}
                                    </Form.Group>
                                )
                            }

                            <Form.Group className="mb-3">
                                <Form.Label>Cost</Form.Label>{" "}
                                <span className="text-danger">*</span>
                                <div className="input-group mb-1">
                                    <input type="text" className="form-control ps-3 p-2" placeholder={"Cost"} {...register("cost", { required: true })} onKeyPress={HelperService.allowOnlyNumericValue} value={watchAllFields.cost} disabled />
                                </div>
                                {errors.cost && (<div className="login-error mb-3"> <Label title={"Please enter cost"} modeError={true} /> </div>)}
                            </Form.Group>

                            <Controller
                                control={control}
                                name="inventory_date"
                                rules={{ required: true, }}
                                render={({ field: { onChange } }) => (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Inventory Date</Form.Label>
                                        <span className="text-danger">*</span>
                                        <div className="input-group mb-1">
                                            <div className="col-12 form-group">
                                                <PlotDatePicker
                                                    selected={watch("inventory_date") ? new Date(watch("inventory_date")) : null}
                                                    onChange={(date: any) => onChange(date)}
                                                    placeholderText="Select Date"
                                                />
                                                {errors.inventory_date && (<Label title={"Please Select Inventory Date."} modeError={true} />)}
                                            </div>
                                        </div>
                                    </Form.Group>
                                )}
                            />

                        </Col>

                    </Row>
                    <div className="text-center border-top">
                        <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="submit" id="changePassword-btn">{isEdit ? "Update" : "Add"}</Button>
                        <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)}>Close</Button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas >
    );
};

export default AddInventory;
